/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityInitiativeDto } from './SecurityInitiativeDto';
import {
    SecurityInitiativeDtoFromJSON,
    SecurityInitiativeDtoFromJSONTyped,
    SecurityInitiativeDtoToJSON,
    SecurityInitiativeDtoToJSONTyped,
} from './SecurityInitiativeDto';

/**
 * 
 * @export
 * @interface InitiativeExportSnapshotDto
 */
export interface InitiativeExportSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeExportSnapshotDto
     */
    schemaVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeExportSnapshotDto
     */
    exportedAt?: Date;
    /**
     * 
     * @type {SecurityInitiativeDto}
     * @memberof InitiativeExportSnapshotDto
     */
    initiative: SecurityInitiativeDto;
}

/**
 * Check if a given object implements the InitiativeExportSnapshotDto interface.
 */
export function instanceOfInitiativeExportSnapshotDto(value: object): value is InitiativeExportSnapshotDto {
    if (!('initiative' in value) || value['initiative'] === undefined) return false;
    return true;
}

export function InitiativeExportSnapshotDtoFromJSON(json: any): InitiativeExportSnapshotDto {
    return InitiativeExportSnapshotDtoFromJSONTyped(json, false);
}

export function InitiativeExportSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeExportSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'schemaVersion': json['schemaVersion'] == null ? undefined : json['schemaVersion'],
        'exportedAt': json['exportedAt'] == null ? undefined : (new Date(json['exportedAt'])),
        'initiative': SecurityInitiativeDtoFromJSON(json['initiative']),
    };
}

export function InitiativeExportSnapshotDtoToJSON(json: any): InitiativeExportSnapshotDto {
    return InitiativeExportSnapshotDtoToJSONTyped(json, false);
}

export function InitiativeExportSnapshotDtoToJSONTyped(value?: InitiativeExportSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schemaVersion': value['schemaVersion'],
        'exportedAt': value['exportedAt'] == null ? undefined : ((value['exportedAt']).toISOString()),
        'initiative': SecurityInitiativeDtoToJSON(value['initiative']),
    };
}

